import { render } from "./ModalElement.vue?vue&type=template&id=7f896f84"
import script from "./ModalElement.vue?vue&type=script&lang=js"
export * from "./ModalElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__